import sift, { createEqualsOperation } from 'sift';
const theMostFrequent = (obj) => {
    const all = Object.values(obj).reduce((acc, value) => {
        const tmp = Array.isArray(value) ? value : [value];
        tmp.forEach((value) => {
            acc.set(value, (acc.get(value) || 0) + 1);
        });
        return acc;
    }, new Map());
    if (all.size === 0) {
        return undefined;
    }
    const entries = [];
    all.forEach((value, key) => {
        entries.push([value, key]);
    });
    entries.sort(([valueA], [valueB]) => {
        return valueB - valueA;
    });
    return entries[0][1];
};
export function createDependencyValidator(dependencies) {
    if (dependencies) {
        return sift(jsonParse(dependencies), {
            operations: {
                $theMostFrequent(params, ownerQuery, options) {
                    return createEqualsOperation((value) => params === theMostFrequent(value), ownerQuery, options);
                },
            },
        });
    }
    return undefined;
}
function jsonParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return '';
    }
}
//# sourceMappingURL=create-dependency-validator.js.map